import Button, { ButtonProps } from "@brighthr/component-button";
import { ReactComponent as ErrorIconSvg } from "shared/assets/Error_Icon.svg";
import { ReactComponent as InfoIconSvg } from "shared/assets/Info_Icon.svg";
import { ReactComponent as SuccessIconSvg } from "shared/assets/Success_Icon.svg";

export interface StatusPageProps {
  status: "info" | "error" | "success";
  title: string;
  body: string;
  cta: ButtonProps;
}

export const StatusPage = (props: StatusPageProps) => {
  const { status, title, body, cta } = props;

  let Icon;
  switch (status) {
    case "error":
      Icon = ErrorIconSvg;
      break;
    case "success":
      Icon = SuccessIconSvg;
      break;
    case "info":
    default:
      Icon = InfoIconSvg;
  }
  return (
    <div data-testid={`${status}-status-screen`} className="flex items-center justify-center h-screen px-6 sm:px-[5rem]">
      <div className="space-y-4 text-center md:w-96">
        <div className="flex justify-center w-full item-center">
          <Icon width={50} height={50} />
        </div>
        <div>
          <h2 className="text-xl font-bold sm:text-2xl text-center">{title}</h2>
          <p className="w-full text-center" dangerouslySetInnerHTML={{ __html: body }}></p>
        </div>
        <div className="space-y-4 pt-4">
          <Button fullWidth size="xl" data-testid={cta.id} color="primary" {...cta} />
        </div>
      </div>
    </div>
  );
};
